"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _boxModel = _interopRequireDefault(require("./boxModel"));

var expandMargin = (0, _boxModel.default)('margin');
var _default = expandMargin;
exports.default = _default;